module.exports = __webpack_public_path__ + "static/media/SofiaProBoldItalic.30b728cd.otf";